<template>
  <a-modal-wrapper
    :modal-name="modalName"
    :initial-focus="getInitialFocusElement"
    :show-scroll-on-close="showScrollOnClose"
    class="image-download-modal__modal-wrapper"
  >
    <div
      class="image-download-modal__wrapper"
      :style="contentDynamicStyles"
      @click="closeModal"
    >
      <i v-focusable class="close-icon" @click="closeModal" />
      <div
        class="image-download-modal__image-wrapper"
        :style="imageWrapperDynamicStyles"
      >
        <img :src="originalUrl" class="image-download-modal__image" />
      </div>
      <div class="image-download-modal__action-wrapper">
        <a
          ref="downloadImage"
          :href="originalUrl"
          class="image-download-modal__download-button"
          target="_blank"
          download
        >
          <span class="text-body bold">
            Download image
          </span>
          <a-icon
            :icon="ICON.DOWNLOAD"
            :width="18"
            :height="18"
            class="image-download-modal__download-icon"
          />
        </a>
        <span class="text-body">Touch/Click anywhere to close</span>
      </div>
    </div>
  </a-modal-wrapper>
</template>

<script>
import { propValidator, PROP_TYPES } from '@/utils/validators'
import AModalWrapper, { MODAL } from 'modals/AModalWrapper'
import AIcon, { ICON } from 'shared/AIcon'
import { hydrationHelpers } from '@/utils/mixins/hydrationHelpers'

export default {
  name: 'AImageDownloadModal',
  mixins: [hydrationHelpers],
  components: { AModalWrapper, AIcon },
  props: {
    modalName: propValidator([PROP_TYPES.STRING], false, MODAL.IMAGE_DOWNLOAD),
    image: propValidator([PROP_TYPES.OBJECT])
  },
  data() {
    return {
      ICON
    }
  },
  computed: {
    contentDynamicStyles() {
      const maxHeight = `calc(100vh - ${this.$_hydrationHelpers_menuHeight}px)`
      return { maxHeight }
    },
    imageWrapperDynamicStyles() {
      const topPadding = 40
      const actionSectionHeight = 70
      const diff =
        topPadding + actionSectionHeight + this.$_hydrationHelpers_menuHeight
      const maxHeight = `calc(100vh - ${diff}px)`
      return { maxHeight }
    },
    originalUrl() {
      const remap = { uRL: 'url', URL: 'url' }
      const { url } = this.$helper.processResponse(this.image, remap)
      return this.$helper.replaceImageUrlSuffixWithOriginal(url)
    },
    showScrollOnClose() {
      return this.modalName !== MODAL.LIVEBYTES_MODAL_IMAGE_DOWNLOAD
    }
  },
  methods: {
    getInitialFocusElement() {
      return this.$refs.downloadImage
    },
    closeModal() {
      this.$helper.closeModal(this.modalName)
    }
  }
}
</script>

<style lang="scss" scoped>
.image-download-modal__modal-wrapper {
  /deep/
    .a-scrollable-content__parent-wrapper
    > .a-scrollable-content__scroll-wrapper {
    width: 100%;
    padding-right: 0;
  }
}

$top-padding: 40px;
$action-section-height: 70px;

.image-download-modal__wrapper {
  position: relative;
  padding-top: $top-padding;

  @include mobile {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .close-icon {
    top: 10px;
    right: 10px;
  }

  .image-download-modal__image-wrapper {
    display: flex;
    justify-content: center;
    height: calc(100% - #{$action-section-height});

    @include mobile {
      height: auto;
    }
  }

  .image-download-modal__image {
    height: 100%;
    max-height: inherit;
    object-fit: contain;
  }

  .image-download-modal__action-wrapper {
    height: $action-section-height;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0 20px;
    background: $c--gray-soft;
  }

  .image-download-modal__download-button {
    display: flex;
    justify-content: center;
    align-items: center;

    &:hover {
      color: $c--main;

      .image-download-modal__download-icon {
        fill: $c--main;
      }
    }
  }

  .image-download-modal__download-icon {
    margin-left: 5px;
  }
}
</style>
